export default __webpack_public_path__ + "static/media/nodata.e9f9331e.svg";